'use client';

import useSWR from 'swr';
import { httpsCallable } from 'firebase/functions';

import { FUNCTIONS } from 'src/lib/firebase';

interface FirestoreFunction<P> {
  name: string;
  payload: P;
  enable?: boolean;
}

export const useFirestoreFunction = <P, R>({
  enable = true,
  name,
  payload,
}: FirestoreFunction<P>) => {
  const swrData = useSWR<R, Error>(
    enable ? [name, payload] : null,
    async ([nameP, payloadP]) => {
      const functionRef = httpsCallable(FUNCTIONS, nameP);
      const response = await functionRef(payloadP);
      return response.data as R;
    },
    {
      revalidateIfStale: true,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  return swrData;
};
